import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../redux/store';

// Use throughout your app instead of plain `useDispatch`
// TODO remove any
// eslint-disable-next-line
const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
